import * as React from 'react';
import { Input, Button, Icon, Layout, Dropdown } from 'antd';
import ComponentBasic from 'kts-scaffold-framework/component/ComponentBasic';
import ChatPanelProps from './ChatPanelProps';
import ChatPanelState from './ChatPanelState';
import UIEmail from './UI.Email';

const css = require('./index.scss');
const { TextArea } = Input;
const { Header, Footer, Sider, Content } = Layout;

class EnterStart {

    /** 输入聊天内容 */
    public text: string;
}

interface EnterProps {
    
    /** 默认输入聊天内容 */
    defaultText: string;

    /** 聊天内容改变 */
    onChangeText?: (value: string) => void;

    /** 用户触发发送 */
    onSend?: (value: string) => void;
}

/** 聊天面板组件 */
export default class Enter extends ComponentBasic<EnterProps, EnterStart> {

    state = new EnterStart();

    constructor(props: EnterProps) {
        super(props);
        this.state.text = this.props.defaultText;
    }

    render() {
        return (
            <Footer className={css.enter}>
                <div className={css['text-area']}>
                    <TextArea
                        onChange={this.onChangeTextAreaHandler}
                        value={this.state.text}
                        placeholder="请输入内容……"
                        autosize={{ minRows: 1, maxRows: 6 }}
                    />
                </div>
                <div className={`clear ${css.box}`}>
                    <UIEmail />
                    <Button type="primary" onClick={this.onClickSendButtonHandler} className={css.dispatch} >发送</Button>
                </div>
            </Footer>
        );
    }

    /** 文本改变事件 */
    private onChangeTextAreaHandler = (e) => {
        this.setState({text: e.target.value});
        if (this.props.onChangeText) {
            this.props.onChangeText(e.target.value);
        }
    }

    /** 点击了发送 */
    private onClickSendButtonHandler = () => {
        if (this.props.onSend) {
            this.props.onSend(this.state.text);
        }
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/ChatPanel/UI.Enter.tsx